import Vue from 'vue';

export default (config) => {
    for (const index in config) {
        const current = config[index];
        Vue.set(current, 'active', true);
        const currentChildren = current.children;
        let validChildrenLength = currentChildren.length;
        for (const innerIndex in currentChildren) {
            const subItem = currentChildren[innerIndex];
            if (subItem.permission === false) validChildrenLength -= 1;
        }
        current['valid_children_length'] = validChildrenLength;
        if (validChildrenLength === 0) {
            current.permission = false;
        }
    }
    return config;
};
